import { EnumOption } from "./enum-option"

export const PhaseStatus = {
    None: 0,
    OffTrack: 1,
    OnTrack: 2,
    NotApplicable: 3,
    Completed: 4,
}

export const PhaseStatusList: EnumOption[] = [
    //{ value: PhaseStatus.None, label: 'None' },
    { value: PhaseStatus.OffTrack, label: 'Off Track' },
    { value: PhaseStatus.OnTrack, label: 'On Track' },
    { value: PhaseStatus.NotApplicable, label: 'Not Applicable' },
    { value: PhaseStatus.Completed, label: 'Completed' },
]
